<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="4" offset-lg="7">
        <v-text-field
          v-model="buscaPersonal"
          rounded
          filled
          placeholder="Buscar aspirante"
          append-icon="mdi-magnify"
          class="search-field"
        ></v-text-field>
      </v-col>
      <v-col lg="1">
        <v-btn-toggle v-model="ordenAlfabetico" class="toggle-buttons" rounded mandatory>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-ascending</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon color="secondary darken-2">mdi-order-alphabetical-descending</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaPersonal.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredPersonal.length }} resultados encontrados con la búsqueda "{{ buscaPersonal }}"
        </div>
      </v-col>
      <v-expansion-panels flat class="modern-expansion" focusable hover mandatory>
        <v-expansion-panel v-for="(grupoPersonal, index) in groupedPersonal" :key="index">
          <v-expansion-panel-header class="expansion-header">
            <div>
              <div class="text-h6 header-letter font-weight-bold d-inline">
                {{ grupoPersonal.inicial }}
              </div>
              <div class="text-overline d-inline header-count">({{ grupoPersonal.personal.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="personal in grupoPersonal.personal" :key="personal.id">
                  <v-card class="aspirante-card" elevation="8">
                    <v-card-title class="card-header">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="center">
                            <v-avatar rounded color="secondary" size="80" v-if="personal.foto.length == 0">
                              <v-icon x-large color="white">mdi-account</v-icon>
                            </v-avatar>
                            <v-img v-else :src="personal.foto" max-height="80" max-width="80"></v-img>
                          </v-col>
                          <v-col cols="12" align="center">
                            <div class="text-h6 name-title font-weight-bold">{{ personal.apaterno }}</div>
                            <div class="text-subtitle-1 name-subtitle">
                              {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-title>
                    <v-card-actions class="card-actions">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="right">
                            <v-tooltip
                              bottom
                              color="black"
                              v-if="
                                perfil === PERFILES['REP_REGISTRO'] ||
                                perfil === PERFILES['REP_ADMINISTRADOR'] ||
                                perfil === PERFILES['Personal/Site']
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{ name: 'registroFotoCuip', params: { id: personal.idPersonal } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-card-text</v-icon></v-btn
                                >
                              </template>
                              <span>Registro de CUIP</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="action-button"
                                  elevation="8"
                                  :to="{
                                    path: 'documentos_personal/' + personal.idPersonal,
                                    params: { id: personal.idPersonal },
                                  }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-file-account</v-icon></v-btn
                                >
                              </template>
                              <span>Ver expediente</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <validacion-asuntos-internos-dialog-component
      :active="asuntosInternosDialog"
      :id-personal="selectedPersonal"
      @close="asuntosInternosDialog = false"
    ></validacion-asuntos-internos-dialog-component>
    <registro-resultados-aspirante-dialog-component
      :active="resultadosDialog"
      :personal="selectedPersonal"
      @close="resultadosDialog = false"
    ></registro-resultados-aspirante-dialog-component>
  </v-container>
</template>
<style scoped>
/* Search Field */
.search-field >>> .v-input__control .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.search-field >>> .v-input__control .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

.search-field >>> .v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.search-field >>> input {
  color: #e0e0e0 !important;
}

.search-field >>> .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

/* Toggle Buttons */
.toggle-buttons {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
}

.toggle-buttons >>> .v-btn {
  border: none !important;
}

.toggle-buttons >>> .v-btn .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  transition: all 0.3s ease !important;
}

.toggle-buttons >>> .v-btn--active .v-icon {
  color: var(--v-secondary-base) !important;
  transform: scale(1.1);
}

/* Results Text */
.text-h6 {
  color: #e0e0e0 !important;
}

/* Expansion Panels */
.modern-expansion {
  background: transparent !important;
}

.modern-expansion >>> .v-expansion-panel {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  transition: all 0.3s ease !important;
}

.modern-expansion >>> .v-expansion-panel:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

.expansion-header {
  background: rgba(0, 0, 0, 0.15) !important;
  border-radius: 16px 16px 0 0 !important;
}

.header-letter {
  color: var(--v-secondary-base) !important;
  font-size: 1.5rem !important;
}

.header-count {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  margin-left: 8px;
}

.modern-expansion >>> .v-expansion-panel-content__wrap {
  background: transparent !important;
  padding: 24px 16px !important;
}

/* Aspirante Cards */
.aspirante-card {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  overflow: hidden;
}

.aspirante-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(var(--v-secondary-base-rgb), 0.4) !important;
  border-color: var(--v-secondary-base) !important;
}

.card-header {
  padding: 20px 16px !important;
  background: rgba(0, 0, 0, 0.2) !important;
}

.name-title {
  color: #e0e0e0 !important;
  margin-top: 12px;
  letter-spacing: 0.5px;
}

.name-subtitle {
  color: rgba(224, 224, 224, 0.8) !important;
  margin-top: 4px;
}

.card-actions {
  background: rgba(0, 0, 0, 0.25) !important;
  padding: 16px !important;
  border-top: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* Action Buttons */
.action-button {
  background: rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: var(--v-secondary-base) !important;
  margin: 0 4px !important;
  transition: all 0.3s ease !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

.action-button:hover {
  background: var(--v-secondary-base) !important;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(var(--v-secondary-base-rgb), 0.5) !important;
}

.action-button >>> .v-icon {
  color: inherit !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.875rem !important;
}

/* Avatar */
::v-deep .v-avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.5) !important;
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

/* v-img for photos */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.5) !important;
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

/* FAB */
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import ValidacionAsuntosInternosDialogComponent from '../../components/enlace/ValidacionAsuntosInternosDialogComponent.vue'
import MarcaActivoDialogComponent from '../../components/enlace/MarcaActivoDialogComponent.vue'
import RegistroResultadosAspiranteDialogComponent from '../../components/enlace/RegistroResultadosAspiranteDialogComponent'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    ValidacionAsuntosInternosDialogComponent,
    MarcaActivoDialogComponent,
    RegistroResultadosAspiranteDialogComponent,
  },

  data() {
    return {
      PERFILES,
      buscaPersonal: '',
      ordenAlfabetico: 0,
      asuntosInternosDialog: false,

      selectedPersonal: null,
      marcaActivoDialog: false,

      resultadosDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('preaspirante', {
      personal: 'getAspirantes',
    }),

    filteredPersonal: function () {
      return this.personal
        .filter((personal) => {
          return (
            this.getFullName(personal).toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0 ||
            personal.rfc.toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0 ||
            personal.curp.toLowerCase().indexOf(this.buscaPersonal.toLowerCase()) >= 0
          )
        })
        .filter((personal) => {
          return personal.CUIP === ''
        })
    },

    groupedPersonal: function () {
      var result = _(this.filteredPersonal)
        .groupBy((personal) => personal.apaterno[0].toUpperCase())
        .map((personal, inicial) => ({ inicial, personal }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },

  methods: {
    openAsuntosInternosDialog(personal) {
      this.selectedPersonal = personal.idPersonal
      this.asuntosInternosDialog = true
    },

    openMarcaActivoDialog(personal) {
      this.selectedPersonal = personal.idPersonal
      this.marcaActivoDialog = true
    },

    openResultadoDialog(personal) {
      this.selectedPersonal = personal
      this.resultadosDialog = true
    },
  },
}
</script>
